// extracted by mini-css-extract-plugin
module.exports = {"labelRotatePic":"AvatarBase64_labelRotatePic__-kJUf"};